// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","brandLogo":"Header_brandLogo__I8tX3","title":"Header_title__hzAP-"};